import { PrineConvertExportData } from './types/PrineConvertExportData';
import { PrineConvertImportData } from './types/PrineConvertImportData';
import { PrineConvertExport } from './PrineConvertExport';
import { PrineConvertImport } from './PrineConvertImport';

export abstract class PrineConvert {
    // We need to clone the data in case the user wants to do multiple exports/imports with the same Instance
    public static cloneData(data: PrineConvertExportData | PrineConvertImportData) {
        return JSON.parse(JSON.stringify(data));
    }

    public static export(data: PrineConvertExportData): PrineConvertExport {
        return new PrineConvertExport(data);
    }

    public static import(data: PrineConvertImportData): PrineConvertImport {
        return new PrineConvertImport(data);
    }
}
